export const NATURE_OF_CALL_SPECIFY = {
  CARGO_OPETATION_SPECIFY: "cargoOperationSpecify",
  WASTE_DISPOSAL_SPECIFY: "wasteDisposalSpecify",
  OTHERS_SPECIFY: "othersSpecify",
} as const;

export const NATURE_OF_CALL = {
  PRIMARY_NATURE_OF_CALL_CODE: "primaryNatureOfCallCode",
  PRIMARY_NATURE_OF_CALL_DESC: "primaryNatureOfCallDesc",
  CARGO_OPERATION: "cargoOperation",
  BUNKERING: "bunkering",
  SURVEY: "survey",
  PROJECTS: "projects",
  HULL_CLEANING: "hullCleaning",
  WASTE_DISPOSAL: "wasteDisposal",
  CREW_CHANGE: "crewChange",
  REPAIRS: "repairs",
  UNDERWATER_INSPECTION: "underwaterInspection",
  STORES_PROVISION: "storesProvision",
  STS: "sts",
  WAITING_ORDERS: "waitingOrders",
  OTHERS: "others",
} as const;

export const NATURE_OF_CALL_ERROR_FIELD = "natureOfCall" as const;

export const PORT_CALL_FORM_FIELDS = {
  PORT_CALL_ID: "id",
  PORT: "port",
  COUNTRY: "country",
  SECURITY_LEVEL_OF_PORT_CALL: "securityLevelOfPortCall",
  ARRIVAL_DATE: "arrivalDate",
  DEPARTURE_DATE: "departureDate",
  COMMENTS: "comments",
} as const;

export const FORM_FIELDS = {
  VESSEL_ID: "vesselId",
  SELECT_PORT: "selectPort",
  EXPECTED_ARRIVAL_LOCATION: "expectedArrivalLocation",
  PREFERRED_ANCHORAGE_AREA: "preferredAnchorageArea",
  REASON_FOR_ANCHORAGE_PREFERENCE: "reasonForAnchoragePreference",
  MASTERS_NAME: "mastersName",
  NATIONALITY: "nationality",
  ETA: "eta",
  ETD: "etd",
  OWNERS_MATTERS_AGENT: "ownersMattersAgent",
  LAST_PORT: "lastPort",
  NEXT_PORT: "nextPort",
  DRAFT_FWD: "draftFwd",
  DRAFT_AFT: "draftAft",
  VESSEL_CONDITION: "vesselCondition",
  CARGO_ONBOARD: "cargoOnboard",
  ...NATURE_OF_CALL,
  ...NATURE_OF_CALL_SPECIFY,
  METHOD_AT_IMO_2020_COMPLIANCE: "methodAtImo2020Compliance",
  PORT_FACILITY: "portFacility",
  PORT_FACILITY_OTHER: "portFacilityOther",
  SECURITY_LEVEL: "securityLevel",
  ISSC_IS_VALID: "isscIsValid",
  ISSC_NUMBER: "isscNumber",
  ISSC_ISSUE_DATE: "issueDate",
  ISSC_EXPIRY_DATE: "expiryDate",
  ISSC_ISSUED_BY: "issuedBy",
  APPROVED_SSP_ONBOARD: "approvedSspOnboard",
  PORT_CALLS: "portCalls",
  LAST_TEN_PORTS_OF_CALL: "lastTenPortsOfCall",
  SPECIAL_SECURITY_MEASURES: "specialSecurityMeasures",
  TAKEN_MEASURES: "takenMeasures",
  SECURITY_GUARDS_ON_BOARD: "securityGuardsOnBoard",
  NUMBER_OF_SECURITY_GUARDS: "numberOfSecurityGuards",
  FLAG_STATE_PERMISSION_DOCUMENT_URL: "flagStatePermissionDocumentUrl",
  ARM_AMMUNITION_ON_BOARD: "armAmmunitionOnBoard",
  ARM_AMMUNITION_PROOF_DOCUMENT_URL: "armAmmunitionProofDocumentUrl",
  VESSEL_HAS_DEFICIENCIES: "vesselHasDeficiencies",
  DEFICIENCIES: "deficiencies",
  DEFICIENCIES_DOCUMENTS_URL: "deficienciesDocumentsUrl",
  LAST_PORT_CLEARANCE_ISSUE_DATE: "lastPortClearanceIssueDate",
  LAST_PORT_CLEARANCE_CLASS_NAME: "lastPortClearanceClassName",
  LAST_PORT_CLEARANCE_DOCUMENT_URL: "lastPortClearanceDocumentUrl",
  NAME_AND_TYPE_OF_SHIP: "nameAndTypeOfShip",
  IMO_NUMBER: "imoNumber",
  CALL_SIGN: "callSign",
  VOYAGE_NUMBER: "voyageNumber",
  PORT_OF_ARRIVAL: "portOfArrival",
  DATE_TIME_OF_ARRIVAL: "dateTimeOfArrival",
  FLAG_STATE_OF_SHIP: "flagStateOfShip",
  NAME_OF_MASTER: "nameOfMaster",
  LAST_PORT_OF_CALL: "lastPortOfCall",
  CERTIFICATE_OF_REGISTRY: "certificateOfRegistry",
  SHIP_AGENT_CONTACT: "shipAgentContact",
  GROSS_TONNAGE: "grossTonnage",
  NET_TONNAGE: "netTonnage",
  VOYAGE_PARTICULARS: "voyageParticulars",
  CARGO_DESCRIPTION: "cargoDescription",
  NUMBER_OF_CREW: "numberOfCrew",
  NUMBER_OF_PASSENGERS: "numberOfPassengers",
  REMARKS: "remarks",
  WASTERESIDUES_REQUIREMENTS: "wasteResidueRequirements",
  COMPLETED_SIGNED_DOCUMENT_URL: "completedAndSignedDocumentUrl",
  CARGO_DECLARATION_DOCUMENT_URL: "cargoDeclarationDocumentUrl",
  SHIPS_STORE_DECLARATION_DOCUMENT_URL: "shipsStoresDeclarationDocumentUrl",
  CREWS_EFFECTS_DECLARATION_DOCUMENT_URL: "crewsEffectsDeclarationDocumentUrl",
  DANGEROUS_GOODS_MANIFEST_DOCUMENT_URL: "dangerousGoodsManifestDocumentUrl",
  ADDITIONAL_REMARKS: "additionalRemarks",
  CALL_ADDITIONAL_DOCUMENTS: "callAdditionalDocuments",
  OTHER_SPECIFY_TYPE: "otherSpecifyType",
  DOCUMENT_TYPE: "documentType",
  DOCUMENT_NAME: "documentName",
  ISSUE_DATE: "issueDate",
  DOCUMENT_SUMMARY: "documentSummary",
  EXPIRY_DATE: "expiryDate",
  DOCUMENT_URL: "documentUrl",
  FILE_FORMAT: "fileFormat",
  FILE_NAME: "fileName",
} as const;

export const CALL_ADDITIONAL_DOCUMENT_TYPES = {
  CERTIFICATE: "CERTIFICATE",
  PERMIT: "PERMIT",
  DOCUMENT: "DOCUMENT",
  VESSEL_MASTER_SOF: "VESSEL_MASTER_SOF",
  PRE_SAILING_MASTER_DECLARATION: "PRE_SAILING_MASTER_DECLARATION",
  INSURANCE: "INSURANCE",
  OTHER_SPECIFY: "OTHER_SPECIFY",
} as const;

export const normalizeCallAdditionalDocumentType = (value?: string | null) => {
  return value?.trim() ?? "";
};

export const STEP_FIELDS: Record<number, string[]> = {
  0: [
    FORM_FIELDS.VESSEL_ID,
    FORM_FIELDS.SELECT_PORT,
    FORM_FIELDS.EXPECTED_ARRIVAL_LOCATION,
    FORM_FIELDS.MASTERS_NAME,
    FORM_FIELDS.NATIONALITY,
    FORM_FIELDS.ETA,
    FORM_FIELDS.ETD,
    FORM_FIELDS.OWNERS_MATTERS_AGENT,
    FORM_FIELDS.LAST_PORT,
    FORM_FIELDS.NEXT_PORT,
    FORM_FIELDS.DRAFT_FWD,
    FORM_FIELDS.DRAFT_AFT,
    FORM_FIELDS.VESSEL_CONDITION,
    FORM_FIELDS.CARGO_ONBOARD,
    FORM_FIELDS.PRIMARY_NATURE_OF_CALL_CODE,
    FORM_FIELDS.PRIMARY_NATURE_OF_CALL_DESC,
    ...Object.values(NATURE_OF_CALL),
    ...Object.values(NATURE_OF_CALL_SPECIFY),
    FORM_FIELDS.METHOD_AT_IMO_2020_COMPLIANCE,
    FORM_FIELDS.PORT_FACILITY,
    FORM_FIELDS.PORT_FACILITY_OTHER,
    FORM_FIELDS.SECURITY_LEVEL,
    FORM_FIELDS.ISSC_IS_VALID,
    FORM_FIELDS.ISSC_NUMBER,
    FORM_FIELDS.ISSC_ISSUE_DATE,
    FORM_FIELDS.ISSC_EXPIRY_DATE,
    FORM_FIELDS.ISSC_ISSUED_BY,
    FORM_FIELDS.APPROVED_SSP_ONBOARD,
    FORM_FIELDS.PORT_CALLS,
    FORM_FIELDS.LAST_TEN_PORTS_OF_CALL,
    FORM_FIELDS.SPECIAL_SECURITY_MEASURES,
    FORM_FIELDS.TAKEN_MEASURES,
    FORM_FIELDS.SECURITY_GUARDS_ON_BOARD,
    FORM_FIELDS.NUMBER_OF_SECURITY_GUARDS,
    FORM_FIELDS.FLAG_STATE_PERMISSION_DOCUMENT_URL,
    FORM_FIELDS.ARM_AMMUNITION_ON_BOARD,
    FORM_FIELDS.ARM_AMMUNITION_PROOF_DOCUMENT_URL,
    FORM_FIELDS.VESSEL_HAS_DEFICIENCIES,
    FORM_FIELDS.DEFICIENCIES,
    FORM_FIELDS.DEFICIENCIES_DOCUMENTS_URL,
    FORM_FIELDS.LAST_PORT_CLEARANCE_ISSUE_DATE,
    FORM_FIELDS.LAST_PORT_CLEARANCE_CLASS_NAME,
    FORM_FIELDS.LAST_PORT_CLEARANCE_DOCUMENT_URL,
  ],
  1: [
    FORM_FIELDS.NAME_AND_TYPE_OF_SHIP,
    FORM_FIELDS.IMO_NUMBER,
    FORM_FIELDS.CALL_SIGN,
    FORM_FIELDS.VOYAGE_NUMBER,
    FORM_FIELDS.PORT_OF_ARRIVAL,
    FORM_FIELDS.DATE_TIME_OF_ARRIVAL,
    FORM_FIELDS.FLAG_STATE_OF_SHIP,
    FORM_FIELDS.NAME_OF_MASTER,
    FORM_FIELDS.LAST_PORT_OF_CALL,
    FORM_FIELDS.CERTIFICATE_OF_REGISTRY,
    FORM_FIELDS.SHIP_AGENT_CONTACT,
    FORM_FIELDS.GROSS_TONNAGE,
    FORM_FIELDS.NET_TONNAGE,
    FORM_FIELDS.VOYAGE_PARTICULARS,
    FORM_FIELDS.CARGO_DESCRIPTION,
    FORM_FIELDS.NUMBER_OF_CREW,
    FORM_FIELDS.NUMBER_OF_PASSENGERS,
    FORM_FIELDS.REMARKS,
    FORM_FIELDS.WASTERESIDUES_REQUIREMENTS,
    FORM_FIELDS.COMPLETED_SIGNED_DOCUMENT_URL,
    FORM_FIELDS.CARGO_DECLARATION_DOCUMENT_URL,
    FORM_FIELDS.SHIPS_STORE_DECLARATION_DOCUMENT_URL,
    FORM_FIELDS.CREWS_EFFECTS_DECLARATION_DOCUMENT_URL,
    FORM_FIELDS.DANGEROUS_GOODS_MANIFEST_DOCUMENT_URL,
    "crew",
  ],
  2: [FORM_FIELDS.ADDITIONAL_REMARKS, FORM_FIELDS.CALL_ADDITIONAL_DOCUMENTS],
};

export const methodAtImo2020ComplianceValues = {
  compliantFuel: "compliantFuel",
  closedLoopExhaustGasScrubber: "closedLoopExhaustGasScrubber",
};

export const vesselConditionOptions = [
  {
    label: "Loaded",
    value: "Loaded",
  },
  {
    label: "Partially Loaded",
    value: "Partially Loaded",
  },

  {
    label: "Ballast",
    value: "Ballast",
  },
];
